import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { TPostSshKeyRotationActivateResponseSchema } from "./postSshKeyRotationActivate.schema";

export const postSshKeyRotationActivate = (axios: IAxiosInstance) => {
  return async (sshKeyRotationId: string) => {
    const response = await axios.noRetry.post<
      IApiResponse<TPostSshKeyRotationActivateResponseSchema>
    >(`/api/sshKeyRotations/${sshKeyRotationId}/activate`);

    if (!response?.data?.success) {
      throw new Error("Something went wrong");
    }

    return response?.data?.data;
  };
};
